import { useEffect, useState } from 'react';

export type ScrollDirection = 'up' | 'down' | 'none';

export type Scroll = {
  lastPosition: number;
  position: number;
  deltaPosition: number;
  direction: ScrollDirection;
  isUp: boolean;
  isDown: boolean;
  isPassThreshold: boolean;
};

type UseScrollOptions = {
  threshold?: number;
};
const useScroll = (options: UseScrollOptions = {}): Scroll => {
  const { threshold = 0 } = options;
  const [lastPosition, setLastPosition] = useState(0);
  const [position, setPosition] = useState(0);
  /** Direction change scroll position is the scroll position when the scroll direction changed */
  const [directionChangePosition, setDirectionChangeScrollPosition] = useState(0);
  const [direction, setDirection] = useState<ScrollDirection>('none');

  useEffect(() => {
    function handleScroll(event) {
      let newDirectionChangeScrollPosition = directionChangePosition;
      const scrollY = window.scrollY;
      const newScrollDirection =
        lastPosition - scrollY === 0 ? 'none' : lastPosition - scrollY > 0 ? 'up' : 'down';
      if (newScrollDirection !== direction) {
        newDirectionChangeScrollPosition = scrollY;
      }
      setDirectionChangeScrollPosition(newDirectionChangeScrollPosition);
      setLastPosition(position);
      setDirection(newScrollDirection);
      setPosition(scrollY);
    }
    const scrollEventListener = (event) => {
      window.requestAnimationFrame(() => {
        handleScroll(event);
      });
    };
    window.addEventListener('scroll', scrollEventListener);
    return () => window.removeEventListener('scroll', scrollEventListener);
  });

  const deltaPosition = position - directionChangePosition;
  const isPassThreshold = Math.abs(deltaPosition) > threshold;

  const isUp = direction === 'up';
  const isDown = direction === 'down';

  return { lastPosition, position, deltaPosition, direction, isUp, isDown, isPassThreshold };
};

export default useScroll;
